import { Component, HostBinding, Input, OnInit } from '@angular/core';

@Component({
  selector: 'cc-white-block',
  templateUrl: './white-block.component.html',
  styleUrls: ['./white-block.component.scss']
})
export class WhiteBlockComponent implements OnInit {
  @Input() fullHeight: boolean;
  @HostBinding('class.full-height') classFullHeight;
  constructor() {}

  ngOnInit() {
    this.classFullHeight = this.fullHeight;
  }
}
